/* RESPONSIBLE TEAM: team-omni */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class SlackIntegrationSerializer extends EmbercomBaseSerializer {
  normalizeArrayResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: any,
    requestType: any,
  ) {
    if (payload && !Array.isArray(payload) && !payload['slack/integrations']) {
      payload = { 'slack/integrations': [payload] };
    } else if (!payload) {
      payload = { 'slack/integrations': [] };
    }
    return super.normalizeArrayResponse(store, primaryModelClass, payload, id, requestType);
  }
}
